<template>

    <div class="my-data__container">

        <header-green v-if="!isNativeUser"></header-green>

        <div class="my-data__bloc-1">

            <div class="desktop__wrapper">

                <h1 class="my-data__bloc-1__title">{{ $t('your_data_title_page') }}</h1>

                <p class="my-data__bloc-1__text">{{ $t('your_data_subtitle_page') }}</p>

            </div>

        </div>


        <div class="my-data__bloc-base my-data__bloc-2">

            <h2 class="my-data__bloc-2__title">{{ $t('your_data_about_cleanfox') }}</h2>

        </div>


        <div class="my-data__bloc-base my-data__bloc-3">

            <h2 class="my-data__bloc-3__title">{{ $t('your_data_users_title') }}</h2>

            <p class="my-data__bloc-3__text">{{ $t('your_data_users_subtitle') }}</p>

            <div class="my-data__bloc-3__group__container">

                <div class="my-data__bloc-3__group__bloc">
                    <div class="my-data__bloc-3__group__bloc-img-container">
                        <img src="/img/my-data/mailsdeleted.svg" class="my-data__bloc-3__group__bloc-img">
                    </div>
                    <p class="my-data__bloc-3__group__bloc-title">{{ this.getFormattedNumber(this.totalMailsDeleted) }}</p>
                    <p class="my-data__bloc-3__group__bloc-text">{{ $t('your_data_stats_emails') }}</p>
                </div>

                <div class="my-data__bloc-3__group__bloc">
                    <div class="my-data__bloc-3__group__bloc-img-container">
                        <img src="/img/my-data/users.svg" class="my-data__bloc-3__group__bloc-img">
                    </div>
                    <p class="my-data__bloc-3__group__bloc-title">{{ this.getFormattedNumber(this.totalUsers) }}</p>
                    <p class="my-data__bloc-3__group__bloc-text">{{ $t('your_data_stats_users') }}</p>
                </div>

                <div class="my-data__bloc-3__group__bloc">
                    <div class="my-data__bloc-3__group__bloc-img-container">
                        <img src="/img/my-data/newslettersunsubscribed.svg" class="my-data__bloc-3__group__bloc-img">
                    </div>
                    <p class="my-data__bloc-3__group__bloc-title">{{ this.getFormattedNumber(this.totalMailsAutoDelete) }}</p>
                    <p class="my-data__bloc-3__group__bloc-text">{{ $t('your_data_newsletters_autodelete') }}</p>
                </div>

            </div>

        </div>

        <div class="my-data__bloc-base my-data__bloc-4">

            <div class="my-data__bloc-4__item my-data__desktop-max-width">

                <div class="my-data__bloc-4__item__header">

                    <h3 class="my-data__bloc-4__item__header-title">Taulita</h3>

                    <div>
                        <img src="/img/icons/star-yellow.svg" class="my-data__bloc-4__item__header-star">
                        <img src="/img/icons/star-yellow.svg" class="my-data__bloc-4__item__header-star">
                        <img src="/img/icons/star-yellow.svg" class="my-data__bloc-4__item__header-star">
                        <img src="/img/icons/star-yellow.svg" class="my-data__bloc-4__item__header-star">
                        <img src="/img/icons/star-yellow.svg" class="my-data__bloc-4__item__header-star">
                    </div>

                </div>

                <div class="my-data__bloc-4__item__subtitle">{{ $t('your_data_comment_app_store') | capitalizeFirstLetter }}</div>

                <q class="my-data__bloc-4__item__text">{{ $t('your_data_comment_taulita') }}</q>

<!--                <div class="my-data__bloc-4__item__point-container">-->
<!--                    <div class="my-data__bloc-4__item__point" :class="{'my-data__bloc-4__item__point-active': true}"></div>-->
<!--                    <div class="my-data__bloc-4__item__point" :class="{'my-data__bloc-4__item__point-active': false}"></div>-->
<!--                    <div class="my-data__bloc-4__item__point" :class="{'my-data__bloc-4__item__point-active': false}"></div>-->
<!--                </div>-->

            </div>

        </div>

        <div class="my-data__bloc-base my-data__bloc-5">

            <div class="my-data__desktop-max-width">

                <h2 class="my-data__page-title">{{ $t('your_data_data_benefit_all_title') }}</h2>

                <p class="my-data__page-subtitle fix__desktop-1">{{ $t('your_data_data_benefit_all_subtitle') }}</p>

                <h3 class="my-data__page-paragraph-header desktop-txt-left">{{ $t('your_data_data_benefit_all_customers_1') }}</h3>

                <p class="my-data__page-paragraph">{{ $t('your_data_data_benefit_all_customers_2') }}</p>


                <h3 class="my-data__page-paragraph-header desktop-txt-left">{{ $t('your_data_data_benefit_all_companies_1') }}</h3>

                <p class="my-data__page-paragraph">{{ $t('your_data_data_benefit_all_companies_2') }}</p>


                <h3 class="my-data__page-paragraph-header desktop-txt-left">{{ $t('your_data_data_benefit_all_NGO_1') }}</h3>

                <p class="my-data__page-paragraph">{{ $t('your_data_data_benefit_all_NGO_2') }}</p>

            </div>

        </div>

        <div class="my-data__bloc-base my-data__bloc-6">

            <h2 class="my-data__page-title my-data__desktop-max-width">{{ $t('your_data_data_collected_title') }}</h2>

            <p class="my-data__page-subtitle my-data__desktop-max-width">{{ $t('your_data_data_collected_subtitle') }}</p>

            <div class="my-data__bloc-6__item-lvl-1">

                <div class="my-data__bloc-6__item-lvl-2 my-data__bloc-6__item-part-1">

                    <div class="my-data__bloc-6__item-lvl-3">

                        <div class="my-data__bloc-6__round">

                            <img src="/img/my-data/newsletterssubcribed.svg" class="my-data__bloc-6__img">

                        </div>

                        <p class="my-data__bloc-6__item-text">{{ $t('your_data_data_collected_icon_1') }}</p>

                    </div>

                    <div class="my-data__bloc-6__item-lvl-3">

                        <div class="my-data__bloc-6__round">

                            <img src="/img/my-data/box.svg" class="my-data__bloc-6__img">

                        </div>

                        <p class="my-data__bloc-6__item-text">{{ $t('your_data_data_collected_icon_2') }}</p>

                    </div>

                </div>

                <p class="my-data__page-paragraph my-data__bloc-6__item-part-2">{{ $t('your_data_data_collected_text') }}</p>

            </div>

        </div>

        <div class="my-data__bloc-base">

            <q class="my-data__page-citation">{{ $t('your_data_personal_data_title') }}</q>

        </div>

        <div class="my-data__bloc-base my-data__bloc-8">

            <div class="my-data__bloc-8__part-left">

                <h2 class="my-data__page-title my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_title') }}</h2>

                <p class="my-data__page-subtitle my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_subtitle') }}</p>

                <h3 class="my-data__page-paragraph-header my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_marketshare_1') }}</h3>

                <p class="my-data__page-paragraph my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_marketshare_2') }}</p>


                <h3 class="my-data__page-paragraph-header my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_loyalty_1') }}</h3>

                <p class="my-data__page-paragraph my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_loyalty_2') }}</p>


                <h3 class="my-data__page-paragraph-header my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_discount_1') }}</h3>

                <p class="my-data__page-paragraph my-data__bloc-8__part-left-text">{{ $t('your_data_data_used_discount_2') }}</p>

            </div>

            <div class="my-data__bloc-8__part-rigth" v-if="$mq === 'lg'">

                <img src="/img/my-data/illustration-interface-data.svg" class="my-data__bloc-8__part-rigth-img">

            </div>

        </div>

        <div class="my-data__bloc-base">

            <q class="my-data__page-citation">{{ $t('your_data_our_choice_title') }}</q>

        </div>

        <div class="my-data__bloc-base my-data__bloc-10">

            <figure class="my-data__figure my-data__bloc-10__part-right">
                <img :src="computedLouisImg" alt="Louis" class="my-data__figure__img">
                <figcaption class="my-data__figure__figcaption">{{ $t('your_data_picture_Louis') }}</figcaption>
            </figure>

            <q class="my-data__page-title my-data__bloc-10__part-left">{{ $t('your_data_quote_Louis') }}</q>

        </div>

        <div class="my-data__bloc-base my-data__bloc-11">

            <div class="my-data__bloc-11__item-1 my-data__bloc-11__item">

                <div class="my-data__bloc-11__round">

                    <img src="/img/my-data/lock.svg" class="my-data__bloc-6__img">

                </div>

                <h3 class="my-data__page-paragraph-header my-data__mtm-24 desktop-txt-left">{{ $t('your_data_privacy_policy_title') }}</h3>

                <p class="my-data__page-paragraph">{{ $t('your_data_privacy_policy_desc') }}</p>

                <a class="my-data__page-link" href="/privacy">{{ $t('your_data_privacy_policy_CTA') }}</a>

            </div>

            <div class="my-data__bloc-11__item-2 my-data__bloc-11__item">

                <div class="my-data__mtm-48 my-data__bloc-11__round">

                    <img src="/img/my-data/paper.svg" class="my-data__bloc-6__img">

                </div>

                <h3 class="my-data__page-paragraph-header my-data__mtm-24 desktop-txt-left">{{ $t('your_data_CGU_title') }}</h3>

                <p class="my-data__page-paragraph">{{ $t('your_data_CGU_desc') }}</p>

                <a class="my-data__page-link" href="/terms">{{ $t('your_data_CGU_CTA') }}</a>

            </div>

            <div class="my-data__bloc-11__item-3 my-data__bloc-11__item">

                <div class="my-data__mtm-48 my-data__bloc-11__round">

                    <img src="/img/my-data/suitcase.svg" class="my-data__bloc-6__img">

                </div>

                <h3 class="my-data__page-paragraph-header my-data__mtm-24 desktop-txt-left">{{ $t('your_data_data_portability_title') }}</h3>

                <p class="my-data__page-paragraph">{{ $t('your_data_data_portability_desc') }}</p>

                <a v-if="ctaMyDataDownload" class="my-data__page-link pointer" @click="getGDPR">{{ $t('your_data_data_portability_CTA') }} {{ $t('privacy_web_only') }}</a>
                <a v-else class="my-data__page-link-unactive" href="/login/email">{{ $t('your_data_data_portability_cta_login') }}</a>

            </div>

        </div>

        <footer-green v-if="!isNativeUser"></footer-green>

    </div>

</template>

<script>

import Api from '@/api'

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import Storage from '@/helpers/storage'

import FooterGreen from '@/components/FooterGreen'
import HeaderGreen from '@/components/headers/HeaderGreen'

export default {

    name: 'my-data',

    components: { FooterGreen, HeaderGreen },

    watch: {

    },

    computed: {

        isNativeUser: function () {
            return this.$route.path.indexOf('/native/') > -1
        },

        computedLouisImg: function () {
            return '/img/my-data/img-louis-mobile.jpg'
        },

        token: function () {
            return Storage.getItem('token')
        },

        ctaMyDataDownload: function () {
            return !!this.token
        }

    },

    data () {
        return {
            totalMailsDeleted: 4512101947,
            totalMailsAutoDelete: 47649465,
            totalUsers: 3039659
        }
    },

    created () {
        UserFlow.setPage(this, 'my-data')
    },

    mounted () {

        window.scrollTo(0, 0)

    },

    methods: {

        getGDPR () {

            Tag.clickAmplitude(this, 'download_gdpr')

            Api.user
                .getGDPR()
                .then(result => {

                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(new Blob([result], { type: 'text/plain' }))
                    link.download = 'cleanfox-data-portability.txt'
                    link.click()

                })
                .catch(() => {
                    this.$refs.toast.open()
                })
        },

        getFormattedNumber(number) {
            return new Intl.NumberFormat(I18n.get(this)).format(number)
        }
    }
}
</script>

<style scoped lang="scss">

    .my-data {


        &__page-title {
            font-size: 34px;
            font-weight: bold;
            line-height: 1.25;
            color: $charcoal;
            @media screen and (min-width: $above-tablet-length) {
                font-size: 34px;
                line-height: 1;
                text-align: center;
            }
        }

        &__page-subtitle {
            margin-top: 16px;
            font-size: 22px;
            font-weight: 500;
            line-height: 1.25;
            color: $moon;
            @media screen and (min-width: $above-tablet-length) {
                font-size: 22px;
                text-align: center;
            }
        }

        &__page-paragraph-header {
            font-size: 22px;
            font-weight: bold;
            line-height: 1.25;
            color: $charcoal;
            margin-top: 40px;
            @media screen and (min-width: $above-tablet-length) {
                font-size: 22px;
                line-height: 1.25;
                text-align: center;
            }
        }

        &__page-paragraph {
            font-size: 17px;
            font-weight: 500;
            line-height: 1.5;
            color: $moon;
            margin-top: 8px;
        }

        &__page-link {
            font-size: 17px;
            font-weight: bold;
            line-height: 1.5;
            color: $forest;
            text-decoration: underline;
        }

        &__page-link-unactive {
            font-size: 17px;
            font-weight: bold;
            line-height: 1.5;
            color: $stone;
        }

        &__page-citation {
            font-size: 22px;
            font-weight: bold;
            line-height: 1.5;
            color: $charcoal;
            @media screen and (min-width: $above-tablet-length) {
                font-size: 34px;
                line-height: 1.25;
                display: flex;
                text-align: center;
            }
        }

        &__mtm-24 {
            margin-top: 24px;
        }

        &__mtm-48 {
            margin-top: 48px;
        }

        &__desktop-max-width {
            @media screen and (min-width: $above-tablet-length) {
                max-width: 644px;
            }
        }


        &__container {
            color: $moon;
            display: flex;
            flex-direction: column;
            @media screen and (min-width: $above-tablet-length) {
                align-items: center;
            }
        }

        &__bloc-1 {
            padding: 132px 16px 242px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: $forest;
            color: $white;
            background-image: url('/img/background/yourdata-illustration-header-reverse.svg');
            background-repeat: no-repeat;
            background-position-x: center;
            background-position-y: bottom;
            background-size: 350px;
            @media screen and (min-width: $above-tablet-length) {
                background-position-x: right;
                background-image: none;
                background-size: 500px;
                align-items: center;
                padding: 327px 64px 0;
                width: 100%;
            }

            &__title {
                font-size: 34px;
                font-weight: bold;
                line-height: 1.25;
                @media screen and (min-width: $above-tablet-length) {
                    font-size: 48px;
                    text-align: left;
                }
            }

            &__text {
                font-size: 22px;
                font-weight: 500;
                line-height: 1.4;
                opacity: 0.88;
                margin-top: 16px;
                @media screen and (min-width: $above-tablet-length) {
                    max-width: 60%;
                    text-align: left;
                }
            }
        }

        &__bloc-base {
            padding: 32px 16px;
            text-align: left;
            color: $moon;
            @media screen and (min-width: $above-tablet-length) {
                padding: 64px;
                max-width: 1312px;
            }
        }

        &__bloc-2 {

            display: flex;
            justify-content: center;
            &__title {
                font-size: 22px;
                font-weight: bold;
                line-height: 1.4;
                color: $charcoal;
                @media screen and (min-width: $above-tablet-length) {
                    font-size: 34px;
                    line-height: 42px;
                    margin-top: 64px;
                    width: 75%;
                    text-align: center;
                }
            }
        }

        &__bloc-3 {

            &__title {
                font-size: 34px;
                font-weight: bold;
                line-height: 1.25;
                color: $charcoal;
                @media screen and (min-width: $above-tablet-length) {
                    text-align: center;
                }
            }

            &__text {
                margin-top: 16px;
                font-size: 22px;
                font-weight: 500;
                line-height: 1.25;
                @media screen and (min-width: $above-tablet-length) {
                    text-align: center;
                }
            }

            &__group {

                &__container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    @media screen and (min-width: $above-tablet-length) {
                        flex-direction: row;
                        justify-content: space-around;
                        margin-top: 80px;
                    }
                }

                &__bloc {
                    margin-top: 40px;
                    width: 194px;
                    text-align: center;
                    @media screen and (min-width: $above-tablet-length) {
                        margin-top: 0;
                    }
                }

                &__bloc-img-container {
                    height: 194px;
                    background-color: $forest;
                    border-radius: 8px;
                    overflow: hidden;
                }

                &__bloc-img {
                    width: 100%;
                    object-fit: contain;
                }

                &__bloc-title {
                    margin-top: 16px;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 1.25;
                    color: $charcoal;
                }

                &__bloc-text {
                    font-size: 17px;
                    font-weight: 500;
                    line-height: 1.5;
                    @media screen and (min-width: $above-tablet-length) {
                        height: 25px;
                    }
                }

            }

        }

        &__bloc-4 {
            display: flex;
            justify-content: center;

            &__item {
                border-radius: 24px;
                border: solid 4px $timberwolf;
                width: 100%;
                padding: 32px;

                &__header {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    @media screen and (min-width: $above-tablet-length) {
                        align-items: baseline;
                        height: 24px;
                    }
                }

                &__header-title {
                    font-size: 17px;
                    font-weight: bold;
                    line-height: 1.5;
                    color: $charcoal;
                }

                &__header-star {
                    width: 24px;
                    object-fit: contain;
                    margin: 0 1px;
                }

                &__subtitle {
                    display: flex;
                    font-size: 17px;
                    font-weight: 500;
                    line-height: 1.5;
                    @media screen and (min-width: $above-tablet-length) {
                        margin-top: 2px;
                    }
                }

                &__text {
                    margin-top: 12px;
                    font-size: 22px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.5;
                    letter-spacing: normal;
                    color: $charcoal;
                    text-align: left;
                    @media screen and (min-width: $above-tablet-length) {
                        display: flex;
                        margin-top: 12px;
                    }
                }

                &__point-container {
                    margin-top: 12px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-end;
                }

                &__point {
                    width: 8px;
                    height: 8px;
                    border-radius: 8px;
                    background-color: $silver;
                    margin: 0 4px;
                }

                &__point-active {
                    background-color: $forest;
                }
            }
        }

        &__bloc-5 {
            @media screen and (min-width: $above-tablet-length) {
                display: flex;
                justify-content: center;
            }
        }

        &__bloc-6 {

            display: flex;
            flex-direction: column;
            align-items: center;

            &__item-lvl-1 {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                @media screen and (min-width: $above-tablet-length) {
                    flex-direction: row;
                    max-width: 866px;
                }
            }

            &__item-lvl-2 {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin: 8px 16px 24px;
            }

            &__item-lvl-3 {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-top: 24px;
                @media screen and (min-width: $above-tablet-length) {
                    flex-direction: row;
                    width: 100%;
                    justify-content: flex-start;
                }
            }

            &__item-part-1 {
                @media screen and (min-width: $above-tablet-length) {
                    flex: 1;
                }
            }

            &__item-part-2 {
                @media screen and (min-width: $above-tablet-length) {
                    flex: 1;
                    margin: 0 12px;
                }
            }

            &__round {
                width: 88px;
                height: 88px;
                background-color: $forest;
                border-radius: 88px;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                @media screen and (min-width: $above-tablet-length) {
                    margin: 0 24px;
                }
            }

            &__img {

            }

            &__item-text {
                margin-top: 16px;
                font-size: 17px;
                font-weight: 600;
                line-height: 1.3;
                color: $charcoal;
                text-align: center;
                @media screen and (min-width: $above-tablet-length) {
                    max-width: 310px;
                    text-align: left;
                    display: flex;
                    flex: 1;
                }
            }
        }

        &__figure {
            display: flex;
            flex-direction: column;
            &__img {
                width: 100%;
                object-fit: contain;
                @media screen and (min-width: $above-tablet-length) {
                    width: 422px;
                }
            }
            &__figcaption {
                font-size: 17px;
                font-weight: 600;
                line-height: 1.29;
                color: $charcoal;
                margin: 16px 0 40px;
                @media screen and (min-width: $above-tablet-length) {
                    width: 422px;
                }
            }
        }

        &__bloc-8 {
            @media screen and (min-width: $above-tablet-length) {
                flex-direction: row;
                display: flex;
            }
            &__part-left {
                @media screen and (min-width: $above-tablet-length) {
                    flex: 1;
                }
            }

            &__part-left-text {
                @media screen and (min-width: $above-tablet-length) {
                    width: 83%;
                    text-align: left;
                }
            }

            &__part-rigth {
                @media screen and (min-width: $above-tablet-length) {
                    position: relative;
                    flex: 1;
                }
            }

            &__part-rigth-img {
                position: absolute;
                right: 0;
                max-width: 40%;
                object-fit: contain;
                @media screen and (min-width: $above-tablet-length) {
                    right: -64px;
                    max-width: 640px ;
                    width: 100%;
                }
            }

        }

        &__bloc-10 {
            @media screen and (min-width: $above-tablet-length) {
                display: flex;
                flex-direction: row-reverse;
                width: 100%;
            }

            &__part-left {
                @media screen and (min-width: $above-tablet-length) {
                    flex: 1;
                    font-size: 48px;
                    line-height: 1.25;
                    text-align: left;
                    margin: 16px;
                }
            }

            &__part-right {
                @media screen and (min-width: $above-tablet-length) {
                    flex: 1;
                    align-items: center;
                }
            }
        }

        &__bloc-11 {
            padding-bottom: 32px;
            @media screen and (min-width: $above-tablet-length) {
                padding-bottom: 64px;
                display: flex;
                flex-direction: row;
            }

            &__item {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            }

            &__item-1 {
                @media screen and (min-width: $above-tablet-length) {
                    margin-right: 12px;
                }
            }

            &__item-2 {
                @media screen and (min-width: $above-tablet-length) {
                    margin: 0 12px;
                }
            }

            &__item-3 {
                @media screen and (min-width: $above-tablet-length) {
                    margin-left: 12px;
                }
            }

            &__round {
                width: 88px;
                height: 88px;
                background-color: $forest;
                border-radius: 88px;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                @media screen and (min-width: $above-tablet-length) {
                  margin: 0;
                }
            }
        }

    }

    .desktop-txt-left {
        @media screen and (min-width: $above-tablet-length) {
            text-align: left;
        }
    }

    .fix {
        &__desktop-1 {
            @media screen and (min-width: $above-tablet-length) {
                margin-bottom: 80px;
            }
        }
    }

    .desktop__wrapper {
        max-width: 1440px;
        @media screen and (min-width: $above-tablet-length) {
            background-position-x: 90%;
            background-image: url('/img/background/yourdata-illustration-header.svg');
            background-size: 500px;
            align-items: center;
            padding: 0 64px 327px;
            width: 100%;
            background-repeat: no-repeat;
            background-position-y: bottom;
        }
    }

</style>
